import styled from 'styled-components';

export const Container = styled.div`
  height: ${({ theme }) => `${theme.heightRodape}px`};
  color: #fff;
  font-size: 12px;
  background: #343a40;
  display: flex;
  align-content: center;
  justify-content: center;
  flex-direction: column;

  text-align: center;
  span {
    vertical-align: center;
  }
`;
